export default {"src":"/_next/static/media/warehouse-icon.78108349.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};